import { type InputTableActionBarButton, InputTableActionBarV2 } from '@/components/custom/erp';
import type { SelectedCellInfo } from '../../../../hooks';
import type { FormMode } from '@/types/form';

interface InputTableActionBarProps {
  mode: FormMode;
  handleAddRow?: () => void;
  handleDeleteRow?: () => void;
  handleCopyRow?: () => void;
  handlePasteRow?: (clipboardText?: string) => void | Promise<void>;
  selectedCell?: SelectedCellInfo | null;
  handleMoveRow?: (direction: 'up' | 'down') => void;
  isPasting?: boolean;
}

const utilityButtons: InputTableActionBarButton[] = [{ type: 'export' }, { type: 'pin' }];

export default function InputTableActionBar(props: InputTableActionBarProps) {
  return <InputTableActionBarV2 {...props} buttons={utilityButtons} />;
}
